import { Panel } from 'primereact/panel';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { CANCELLED, SUCCESS } from '../../../shared/Constants';

const i18nMessages = defineMessages({
  buyCredits: {
    id: 'menu.creditsManagement.buy-credits',
    defaultMessage: 'Buy Credits',
  },
  sendPaymentLink: {
    id: 'buy-credits.send-payment-link',
    defaultMessage: 'Send payment link',
  },
  purchasingFor: {
    id: 'buy-credits.purchasing-for',
    defaultMessage: 'Purchasing for: ',
  },
  purchaser: {
    id: 'buy-credits.purchaser',
    defaultMessage: 'Purchaser: ',
  },
  price: {
    id: 'buy-credits.price',
    defaultMessage: 'Price: ',
  },
  selectQuantity: {
    id: 'buy-credits.select-quantity',
    defaultMessage: 'Select quantity',
  },
  payNow: {
    id: 'account.generic.pay-now',
    defaultMessage: 'Pay now',
  },
  successfulPayment: {
    id: 'buy-credits.successful-payment',
    defaultMessage: '{amountOfCredits} Credits have been delivered to {accountName}',
  },
  cancelledPayment: {
    id: 'buy-credits.cancelled-payment',
    defaultMessage: 'The payment was cancelled and no Credits have been transferred to your account',
  },
  paymentGenericError: {
    id: 'buy-credits.payment-generic-error',
    defaultMessage: 'There was an error trying to process your payment',
  },
  thankYou: {
    id: 'buy-credits.thank-you',
    defaultMessage: 'Thank you!',
  },
  sorry: {
    id: 'buy-credits.sorry',
    defaultMessage: "We're sorry",
  },
  errorHeader: {
    id: 'buy-credits.error',
    defaultMessage: 'Error!',
  },
});

const CreditPaymentFinalized = ({ paymentResultType, amountOfCredits, accountName }) => {
  const { formatMessage } = useIntl();

  const getHeader = () => {
    switch (paymentResultType) {
      case SUCCESS:
        return formatMessage(i18nMessages.thankYou);
      case CANCELLED:
        return formatMessage(i18nMessages.sorry);
      default:
        return formatMessage(i18nMessages.errorHeader);
    }
  };

  const getContent = () => {
    switch (paymentResultType) {
      case SUCCESS:
        return formatMessage(i18nMessages.successfulPayment, {
          amountOfCredits,
          accountName,
        });
      case CANCELLED:
        return formatMessage(i18nMessages.cancelledPayment);
      default:
        return formatMessage(i18nMessages.paymentGenericError);
    }
  };

  const header = getHeader(paymentResultType);
  const content = getContent(paymentResultType);

  return (
    <div className="brand-detailed-wrapper">
      <Panel header={formatMessage(i18nMessages.buyCredits)}>
        <div className="result">
          <div className="header">{header}</div>
          <div className="content">{content}</div>
        </div>
      </Panel>
    </div>
  );
};

export default CreditPaymentFinalized;
